export default __webpack_public_path__ + "static/media/ico_7.52ad3915.png";